module.exports = __webpack_public_path__ + "img/114.c6f94355.svg";